import React, { use, useCallback } from 'react'

import { useDropzone } from 'react-dropzone'
import { Box, Text } from '@chakra-ui/react'

import { useInterview } from '@/react-query/interview/interview'
import { useLocalRecording } from '@/react-query/local-recording'
import FileUploader from '@/views/components/FileUploader'
import { InputTranscriptContext } from '@/views/screens/Interview/components/FullTranscript/context/InputTranscriptContext'
import { useAudioRecorder } from '@/views/screens/Interview/context/AudioRecorderContext/AudioRecorderContext'

import { AudioRecorder } from '../../AudioRecorder/AudioRecorder'

export const ToolboxActions = () => {
  const { startFileTranscription } = use(InputTranscriptContext)
  const interview = useInterview().data

  const { isRecording } = useAudioRecorder()

  const onDrop = useCallback((acceptedFiles: File[]) => {
    const file = acceptedFiles[0]
    if (!file) {
      return
    }
    startTranscriptionForFile(file).catch(console.error)
  }, [])

  const { getRootProps, getInputProps, isDragActive, inputRef } = useDropzone({
    onDrop,
    accept: {
      'video/*': [],
      'audio/*': [],
    },
    noClick: true,
    noKeyboard: true,
  })

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file = event.target.files?.[0]
    if (!file) {
      return
    }

    await startTranscriptionForFile(file)
  }

  const startTranscriptionForFile = async (file: File) => {
    if (!interview) return

    try {
      await startFileTranscription({
        file,
        source: 'localUpload',
        interviewId: interview.id,
      })
    } catch (error) {
      console.error(error)
    }
  }

  const { data: recording } = useLocalRecording()

  return (
    <Box {...getRootProps()} className="relative w-full">
      <Box className="flex flex-row items-center gap-3">
        <AudioRecorder />
        {!isRecording && !recording && (
          <>
            <Text>or</Text>
            <FileUploader
              name="recordingFile"
              id="recordingFile"
              onFileChange={handleFileChange}
              acceptedFileTypes="audio/*,video/*,audio/mp4,audio/x-m4a,audio/aac,.m4a"
              minW={'auto'}
              inputProps={getInputProps()}
              inputRef={inputRef}
            >
              Upload recording...
            </FileUploader>
          </>
        )}
      </Box>
      {isDragActive && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          zIndex={100}
          display="flex"
          justifyContent="center"
          alignItems="center"
          rounded={'2.5rem'}
          bg={'#F5F5F5'}
          border={'2px dashed #C4C4C4'}
        >
          <Text color={'blackAlpha.700'} fontWeight={'bold'} fontSize={'xl'}>
            Drop interview recording here
          </Text>
        </Box>
      )}
    </Box>
  )
}
